import ApplicationSerializer from 'eflex/serializers/application';

export default class SpindleProcessDatumSerializer extends ApplicationSerializer {
  attrs = {
    multispindleProcessDatum: {
      serialize: false,
      deserialize: false,
    },
  };
}
